import React from 'react'
import LOLTeam from '../components/LOLTeam'
import ValorantTeam from '../components/ValorantTeam'

function equipes() {
  return (
    <>
        <ValorantTeam/>
        <LOLTeam/>
    </>
  )
}

export default equipes